import React, { Component, Fragment, useState } from "react";
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import { Link } from "react-router-dom";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Sidebar from "../../components/Sidebar";



import circle from '../../assets/images/circle.gif';
import box from '../../assets/images/box.png';
import rocket from '../../assets/images/rocket.png';
import minebox from '../../assets/images/minebox.png';

import ques from '../../assets/images/ques.png';
import original from '../../assets/images/original.png';
import live from '../../assets/images/live.png';
import lottery1 from '../../assets/images/lottery.png';
import BannerImg from '../../assets/images/bannerImage.png';

import commingsoon from "../../assets/images/cs-bg.png";


import { getUserHomepage, getBannerInfo } from "../../Features/SiteSettings/siteSettingSlice";
import { useTranslation, I18nextProvider } from "react-i18next";

import { getGamesLists } from "../../Features/GameCommon/gameCommonSlice";


import {
  verifyWithdrawreq
} from "../../Features/Bankdetails/bankDetailsSlice";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { useDispatch } from "react-redux";
import { useCustomizeContext } from "../../context";

import { useNavigate } from "react-router";
import { useEffect } from "react";



const Home = (props) => {


  const { t, i18n } = useTranslation();
  var settings = {
    dots: false,
    infinite: true,
    arrows: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
    ],
  };
  let navigate = useNavigate()
  const {
    loader: { loading, setLoading },
    modelStatus: { modal, setModal, modal1, setModal1, modal2, setModal2 },
    userAuthToken: { userToken, setUserToken },
    languageContext: {
      language, setLanguage,
      changeLanguageRes, setChangeLanguageRes,
    },
    sideMenu: {
      classIsActive, setClassIsActive,
      isOpen, setSideMenuOpen
    },
  } = useCustomizeContext();





  const [activeTab, setActiveTab] = useState("1");
  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const togglePopLogin = () => setModal(!modal);

  const togglePopForgot = () => setModal1(!modal1);

  const togglePopRegister = () => setModal2(!modal2);

  // DEMO
  let dispatch = useDispatch();
  // home title
  const [hometitle, setHometitle] = useState("");
  const [hometitle1, setHometitle1] = useState("");
  const [hometitle2, setHometitle2] = useState("");
  const [hometitle3, setHometitle3] = useState("");
  const [hometitle4, setHometitle4] = useState("");

  // home description
  const [homedescription, setHomedescription] = useState("");
  const [homedescription1, setHomedescription1] = useState("");
  const [homedescription2, setHomedescription2] = useState("");
  const [homedescription3, setHomedescription3] = useState("");
  const [homedescription4, setHomedescription4] = useState("");
  // home images
  const [homeimage, setHomeimage] = useState("");
  const [homeimage1, setHomeimage1] = useState("");
  const [homeimage2, setHomeimage2] = useState("");
  const [homeimage3, setHomeimage3] = useState("");
  const [homeimage4, setHomeimage4] = useState("");
  const [homeimage5, setHomeimage5] = useState("");

  let linkUrlParams = new URLSearchParams(window.location.search);



  let withapproveVerify = linkUrlParams.get("approve");
  let withrejectVerify = linkUrlParams.get("reject");


  const [getAllGameRes, setAllGamesRes] = useState([]);

  const [bannerRes, setBannerRes] = useState([]);

  useEffect(() => {
    userHomepage();
  }, [changeLanguageRes]);

  useEffect(() => {
    getBannerImages();
  }, []);

  const getBannerImages = async () => {
    let res = await dispatch(getBannerInfo());
    if (res?.status) {
      setBannerRes(res?.data);
    }
    else {
      setBannerRes([]);
    }
  }


  useEffect(() => {

    if (withapproveVerify || withrejectVerify) {
      verifywithdraw();
    }

  }, [withapproveVerify, withrejectVerify]);

  useEffect(() => {
    let token = localStorage.getItem("loginToken")
    setUserToken(token);
  }, []);


  useEffect(() => {
    window.scrollTo(0, 0);
  }, [isOpen]);

  useEffect(() => {
    setClassIsActive(false);
    document.body.classList.remove("SideMenuOpen");
  }, [isOpen]);


  //  Slider

  var settings = {
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    prevArrow: (<button type='button' class='slick-prev'><svg width='6' height='9' viewBox='0 0 6 9' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M1 1L5 4.5L1 8' stroke='white' /></svg></button>),
    nextArrow: (<button type='button' class='slick-next'><svg width='6' height='9' viewBox='0 0 6 9' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M1 1L5 4.5L1 8' stroke='white' /></svg></button>),
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 4,

        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,

        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        }
      },

    ]
  };




  var settings2 = {
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    prevArrow: (<button type='button' class='slick-prev hmBnrAr lt'><svg width='6' height='9' viewBox='0 0 6 9' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M1 1L5 4.5L1 8' stroke='white' /></svg></button>),
    nextArrow: (<button type='button' class='slick-next hmBnrAr rt'><svg width='6' height='9' viewBox='0 0 6 9' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M1 1L5 4.5L1 8' stroke='white' /></svg></button>)
  };



  const verifywithdraw = async () => {
    setLoading(true);
    let res = await dispatch(verifyWithdrawreq({ verificationid: withapproveVerify ? withapproveVerify : withrejectVerify }));
    setTimeout(() => {
      if (res?.status) {
        setLoading(false);
        navigate("/")

      }
      else {
        setLoading(false);
        navigate("/")
      }
    }, 1000);
  }



  const userHomepage = async () => {
    setLoading(true);
    let res = await dispatch(getUserHomepage({ type: "user", "language": localStorage.getItem("lang") }));

    setTimeout(() => {
      if (res?.status) {
        setHometitle(res?.data?.title_1);
        setHometitle1(res?.data?.title_2);
        setHometitle2(res?.data?.title_3);
        setHometitle3(res?.data?.title_4);
        setHometitle4(res?.data?.title_5);

        setHomedescription(res?.data?.description_1);
        setHomedescription1(res?.data?.description_2);
        setHomedescription2(res?.data?.description_3);
        setHomedescription3(res?.data?.description_4);
        setHomedescription4(res?.data?.description_5);
        setHomeimage(res?.data?.image_1);
        setHomeimage1(res?.data?.image_2);
        setHomeimage2(res?.data?.image_3);
        setHomeimage3(res?.data?.image_4);
        setHomeimage4(res?.data?.image_4);
        setHomeimage5(res?.data?.image_6);
        setLoading(false);
      }
      else {
        setLoading(false);
      }
    }, 1000);
  }

  useEffect(() => {
    getAllGames();
  }, []);

  const getAllGames = async () => {
    setLoading(true);
    let res = await dispatch(getGamesLists());
    if (res?.status) {
      setAllGamesRes(res?.data);
      setLoading(false);
    }
    else {
      setLoading(false);
    }
  }



  return (
    <Fragment>
      <Header />
      <div class="mainbody-content">
        <Sidebar />
        <div class="center-maincnt">
          <div class="inr-container">
            <div class="center-inrcnt">
              <div class="homepage-maincnt">


                <section class="getreward-boxsec-pt">
                  <Slider {...settings2}>
                    {
                      bannerRes?.length > 0 ? bannerRes?.map((temp, index) =>
                        <div class="slider-item" key={index}>
                          <section class="getreward-boxsec v2">
                            <div class="getreward-boxsec-ol v2">
                              <img style={{ cursor: "pointer" }} src={temp?.icon} alt="bnrBg" onClick={userToken ? () => navigate(temp?.routes) : togglePopRegister} role="button" />
                            </div>
                            <div class="row align-items-center d-none">
                              <div class="col-lg-6">
                                <div class="reward-leftcnt">
                                  <h5>{hometitle}</h5>
                                  <h2>{hometitle3}</h2>
                                  <p>{homedescription}</p>
                                  {
                                    userToken ?
                                      null
                                      :
                                      <Link to="" onClick={userToken ? "" : togglePopRegister} class="btn-yellow">
                                        {t("Sign up")}
                                        <img src={circle} alt="" class="img-fluid circle-gif" />
                                      </Link>
                                  }
                                </div>
                              </div>
                              <div class="col-lg-6 text-center mt-4 mt-lg-0">
                                <div class="reward-rightcnt">
                                  <img src={box} alt="" class="img-fluid" />
                                </div>
                              </div>
                            </div>
                          </section>
                        </div>
                      )
                        :
                        <div class="slider-item">
                          <section class="getreward-boxsec">
                            <div class="getreward-boxsec-ol">
                              <img src={BannerImg} alt="bnrBg" />
                            </div>
                            <div class="row align-items-center d-none">
                              <div class="col-lg-6">
                                <div class="reward-leftcnt">
                                  <h5>{hometitle}</h5>
                                  <h2>{hometitle3}</h2>
                                  <p>{homedescription}</p>
                                  {
                                    userToken ?
                                      null
                                      :
                                      <Link to="" onClick={userToken ? "" : togglePopRegister} class="btn-yellow">
                                        {t("Sign up")}
                                        <img src={circle} alt="" class="img-fluid circle-gif" />
                                      </Link>
                                  }
                                </div>
                              </div>
                              <div class="col-lg-6 text-center mt-4 mt-lg-0">
                                <div class="reward-rightcnt">
                                  {/* <img src={box} alt="" class="img-fluid" /> */}
                                </div>
                              </div>
                            </div>
                          </section>
                        </div>

                    }
                  </Slider>
                </section>


                <section class="crashmine-sec mt-4">
                  <div class="row">
                    <div class="col-lg-8 col-xl-6 mx-auto">
                      <div class="crashmine-graybox">
                        <div class="row align-items-center h-100">
                          <div class="col-md-7">
                            <div class="crashmine-leftcnt">
                              <h5>Crash</h5>
                              <p>{homedescription1}
                              </p>
                              <Link to="/crash" class="btn-yellow">
                                {t("Play Now")}
                                <img src={circle} alt="" class="img-fluid circle-gif" />
                              </Link>
                            </div>
                          </div>
                          <div class="col-md-5 text-center">
                            <div class="crashmine-rightcnt">
                              <img src={rocket} alt="" class="img-fluid" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-8 col-xl-6 mt-4 mx-auto mt-xl-0">
                      <div class="crashmine-graybox">
                        <div class="row align-items-center h-100">
                          <div class="col-md-7">
                            <div class="crashmine-leftcnt">
                              <h5>Mines</h5>
                              <p>{homedescription2}
                              </p>
                              <Link to="/mines" class="btn-yellow">
                                {t("Play Now")}
                                <img src={circle} alt="" class="img-fluid circle-gif" />
                              </Link>
                            </div>
                          </div>
                          <div class="col-md-5 text-center">
                            <div class="crashmine-rightcnt">
                              <img src={minebox} alt="" class="img-fluid minebox-Img" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section class="game-sec mt-4">
                  <div class="game-tabul">
                    <Nav tabs>
                      {/* <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === '2' })}
                          onClick={() => { toggle('2'); }}
                        >
                          <img src={slotss} alt="" class="img-fluid" />
                          {t("Slots")}
                        </NavLink>
                      </NavItem> */}
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === '3' })}
                          onClick={() => { toggle('3'); }}
                        >
                          <img src={live} alt="" class="img-fluid" /> {t("Live Casino")}
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === '1' })}
                          onClick={() => { toggle('1'); }}
                        >
                          <img src={original} alt="" class="img-fluid" />
                          {/* {t("Original")}  {t('Games')} */}
                          {t('Casino')}
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === '4' })}
                          onClick={() => { toggle('4'); }}
                        >
                          <img src={lottery1} alt="" class="img-fluid" /> {t("Sports")}
                        </NavLink>
                      </NavItem>
                    </Nav>
                  </div>


                  <div class="game-tabcnt">

                    {/* Game Lists Start */}

                    <TabContent activeTab={activeTab}>
                      <TabPane tabId="1">
                        <div class="originalgame-tabinrcnt">
                          <div class="game-maingrid game-maingridDsktp">
                            {
                              getAllGameRes?.map((temp, index) =>
                                <div key={index} style={{ cursor: "pointer" }} class="game-inrbox" onClick={() => navigate(temp?.routes)}>
                                  <div class="gameinr-img">
                                    <img src={temp?.gameIcon} alt="Game Logo" class="img-fluid" />
                                  </div>
                                  <div class="gameinr-cnt">
                                    <div class="gameinr-flex">
                                      <h5>{temp?.game_name}</h5>
                                      <button>
                                        <img src={ques} alt="" class="img-fluid" />
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              )

                            }
                          </div>
                          <div class="searchresult-mainbox MblViwSldr">
                            <div class="searchresult-inrcnt">
                              <div class="search-slider">
                                <div class="slider multiple-items">
                                  <Slider {...settings}>
                                    {
                                      getAllGameRes?.length > 0 ?

                                        getAllGameRes?.map((temp, index) =>
                                          <div class="slider-item" key={index}>

                                            {/* <img src={game?.gameIcon} alt="" style={{ cursor: "pointer" }} onClick={() => { navigate(temp?.routes) }} class="img-fluid" /> */}

                                            <div style={{ cursor: "pointer" }} class="game-inrbox" onClick={() => navigate(temp?.routes)}>
                                              <div class="gameinr-img">
                                                <img src={temp?.gameIcon} alt="Game Logo" class="img-fluid" />
                                              </div>
                                              <div class="gameinr-cnt">
                                                <div class="gameinr-flex">
                                                  <h5>{temp?.game_name}</h5>
                                                  <button>
                                                    <img src={ques} alt="" class="img-fluid" />
                                                  </button>
                                                </div>
                                              </div>
                                            </div>

                                          </div>
                                        )
                                        :
                                        <div className="searchNoData">{t('No Game Found')}</div>
                                    }
                                  </Slider>
                                </div>
                              </div>


                            </div>
                          </div>

                        </div>
                      </TabPane>

                      {/*  ====  Game Lists ==== End  ====*/}


                      <TabPane tabId="2">
                        <div class="originalgame-tabinrcnt" style={{ display: "flex", justifyContent: "center" }}>
                          <img src={commingsoon} alt="Comming Soon" class="img-fluid" />
                        </div>
                      </TabPane>
                      <TabPane tabId="3">
                        <div class="originalgame-tabinrcnt" style={{ display: "flex", justifyContent: "center" }}>
                          <img src={commingsoon} alt="Comming Soon" class="img-fluid" />
                        </div>
                      </TabPane>
                      <TabPane tabId="4">
                        <div class="originalgame-tabinrcnt" style={{ display: "flex", justifyContent: "center" }}>
                          <img src={commingsoon} alt="Comming Soon" class="img-fluid" />
                        </div>
                      </TabPane>
                    </TabContent>
                  </div>
                </section>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </Fragment>
  );

}

export default Home;